<template>
  <div class="flex gap-4 text-start col-span-9">
    <ProtectedAvatar :src="resolvedPhoto" :size="64">
      <div class="w-full h-full rounded-full bg-primary flex items-center justify-center">
        <span class="text-white font-bold">{{ doctor.name?.substring(0, 2).toUpperCase() }}</span>
      </div>
    </ProtectedAvatar>
    <div class="overflow-clip">
      <p class="font-bold truncate" :title="doctor.name">{{ doctor.name }}</p>
      <p class="truncate" :title="doctor.email">{{ doctor.email }}</p>
      <p>{{ doctor.phone }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { resolveAvatarSrc } from '@/utils/avatar'
import ProtectedAvatar from '@/components/designSystem/AvatarUser/ProtectedAvatar.vue'

const props = defineProps<{
  doctor: {
    photo: string
    name: string
    email: string
    phone: string
  }
}>()

const resolvedPhoto = computed(() => resolveAvatarSrc(props.doctor.photo))
</script>
